/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useTranslation } from "react-i18next";
import {
  MapPin,
  Landmark,
  CircleDollarSign,
  Save,
  Loader2,
} from "lucide-react";
import apicache from "../../components/clearCach/clear";

function CountryCurrency() {
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useStoreFormDraft(store);
  const [showSideBar, setShowSideBar] = useState(true);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const message = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success mx-2",
        cancelButton: "btn btn-danger mx-2",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title:
          t("services.contact_for_free_trial"),
        showCancelButton: true,
        confirmButtonText: t("ship.yes"),
        cancelButtonText: t("ship.no"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.open("https://m.me/F0orweb", "_blank", "noopener,noreferrer");
        } else result.dismiss === Swal.DismissReason.cancel;
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    apicache(account, products);
    setLoading(true);
    try {
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      Swal.fire({
        icon: "success",
        title: t("settings.success"),
        confirmButtonText: t("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } catch (error) {
      Swal.fire({ icon: "error", title: t("ui.notSaved"), confirmButtonText: t("ship.ok") });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d] flex flex-col gap-y-6">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-0">
                  {t("countryCurrencySettings.page_title")}
                </h2>
                <p className="text-gray-600 dark:text-gray-400 mb-0">
                  {t("countryCurrencySettings.page_subtitle")}
                </p>
              </div>
            </div>
          </div>

          {/* Main Content */}
          {!!data && (
            <form onSubmit={!!account.store ? handleSubmit : message}>
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="mb-6">
                  {/* Alerte en haut */}
                  <div className="bg-[#fcf6ff] dark:!bg-[#181819] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                    <div className="flex items-start gap-3">
                      <div className="p-2 bg-[#faf1ff] dark:!bg-[#3c3a3d] rounded-full text-[#9e68ba]">
                        <CircleDollarSign size={20} />
                      </div>
                      <div>
                        <h3 className="text-[#9e68ba] font-semibold text-xl mb-1">
                          {t("countryCurrencySettings.alert_title")}
                        </h3>
                        <p className="text-[#9e68ba] text-sm">
                          {t("countryCurrencySettings.alert_text")}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Grid inputs */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Country Selection */}
                    <div>
                      <label className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-2">
                        {t("countryCurrencySettings.country_label")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                          <MapPin size={18} className="text-gray-400 dark:text-gray-500" />
                        </div>
                        <select
                          required
                          value={data.country}
                          onChange={(e) => setData({ ...data, country: e.target.value })}
                          className={`w-full py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent appearance-none bg-white dark:!bg-[#181819] text-gray-800 dark:text-gray-200 ${i18n.dir() === "rtl"
                              ? "pr-10 pl-4 text-right"
                              : "pl-10 pr-4 text-left"
                            }`}
                        >
                          <option value="">
                            {t("countryCurrencySettings.select_country")}
                          </option>
                          <option value={"الجزائر"}>
                            {t("countryCurrencySettings.countries.algeria")}
                          </option>
                          <option value={"المغرب"}>
                            {t("countryCurrencySettings.countries.morocco")}
                          </option>
                          <option value={"تونس"}>
                            {t("countryCurrencySettings.countries.tunisia")}
                          </option>
                          <option value={"مصر"}>
                            {t("countryCurrencySettings.countries.egypt")}
                          </option>
                          <option value={"ليبيا"}>
                            {t("countryCurrencySettings.countries.libya")}
                          </option>
                          <option value={"فلسطين"}>
                            {t("countryCurrencySettings.countries.palestine")}
                          </option>
                          <option value={"الاردن"}>
                            {t("countryCurrencySettings.countries.jordan")}
                          </option>
                          <option value={"السعودية"}>
                            {t("countryCurrencySettings.countries.saudi_arabia")}
                          </option>
                          <option value={"العراق"}>
                            {t("countryCurrencySettings.countries.iraq")}
                          </option>
                          <option value={"الكويت"}>
                            {t("countryCurrencySettings.countries.kuwait")}
                          </option>
                          <option value={"البحرين"}>
                            {t("countryCurrencySettings.countries.bahrain")}
                          </option>
                          <option value={"الامارات"}>
                            {t("countryCurrencySettings.countries.uae")}
                          </option>
                          <option value={"قطر"}>{t("countryCurrencySettings.countries.qatar")}</option>
                          <option value={"عمان"}>{t("countryCurrencySettings.countries.oman")}</option>
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 dark:text-gray-400">
                          <svg
                            className="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                          </svg>
                        </div>
                      </div>
                    </div>

                    {/* Currency Name */}
                    <div>
                      <label className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-2">
                        {t("countryCurrencySettings.currency_name_label")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                          <Landmark size={18} className="text-gray-400 dark:text-gray-500" />
                        </div>
                        <input
                          type="text"
                          placeholder={t("countryCurrencySettings.currency_name_placeholder")}
                          value={data.currency}
                          onChange={(e) => setData({ ...data, currency: e.target.value })}
                          className="w-full pr-4 pl-10 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent bg-white dark:!bg-[#181819] text-gray-800 dark:text-gray-200"
                        />
                      </div>
                    </div>

                    {/* Currency Symbol */}
                    <div className="md:col-span-2">
                      <label className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-2">
                        {t("countryCurrencySettings.currency_symbol_label")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                          <CircleDollarSign size={18} className="text-gray-400 dark:text-gray-500" />
                        </div>
                        <input
                          type="text"
                          placeholder={t("countryCurrencySettings.currency_symbol_placeholder")}
                          value={data.currencySymbol}
                          onChange={(e) =>
                            setData({ ...data, currencySymbol: e.target.value })
                          }
                          className="w-full pr-4 pl-10 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent bg-white dark:!bg-[#181819] text-gray-800 dark:text-gray-200"
                        />
                      </div>
                      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 pr-1">
                        {t("countryCurrencySettings.currency_symbol_note")}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Save Button */}
                <div className="flex justify-center mt-6">
                  <button
                    type="submit"
                    disabled={loading}
                    className={`py-2 px-6 rounded-lg ${loading
                      ? "bg-purple-400"
                      : "bg-[#9b59bf] hover:bg-[#814a9f]"
                      } text-white font-medium flex items-center gap-2 transition-colors shadow-sm`}
                  >
                    {loading ? (
                      <>
                        <Loader2 size={18} className="animate-spin" />
                        {t("countryCurrencySettings.submit_button_loading")}
                      </>
                    ) : (
                      <>
                        <Save size={18} />
                        {t("countryCurrencySettings.submit_button")}
                      </>
                    )}
                  </button>
                </div>
              </div>
            </form>
          )}
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default CountryCurrency;
